export const Badge = {
  variants: {
    upperRightCorner: {
      position: "absolute",
      top: 0,
      right: 0,
      p: 0,
      marginTop: 0,
      marginRight: 0,
      width: 80,
      height: 80
    }
  }
};
